import Vue from 'vue'
import Vuex from 'vuex'
// import feathers from '@/feathers/'
import uniqid from 'uniqid'
import entities from './entities'
// import distance from '@turf/distance'
import debounce from 'lodash.debounce'

import SERVER_URL from '@/config'
// import { stat } from 'fs';

const feathers = require('feathers/client')
const socketio = require('feathers-socketio/client')
const hooks = require('feathers-hooks')
// const errors = require('feathers-errors')
const auth = require('feathers-authentication-client')
const io = require('socket.io-client/dist/socket.io')

const socket = io(SERVER_URL, {
  transports: ['websocket']
})

const storage = localStorage

const feathersClient = feathers()
  .configure(socketio(socket, {
    timeout: 30000
  }))
  .configure(hooks())
  .configure(auth({ storage }))

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    entities
  },
  state: {
    online: 'on',
    windowEvents: false,
    light: ![null, 'false'].includes(localStorage.getItem('light')),
    loading: false,
    serverURL: SERVER_URL,
    feathers: feathersClient,
    auth: {
      user: null,
      token: null
    },
    log: {
      limit: 10,
      page: 1,
      open: false,
      items: [],
      filter: 'toate'
    },
    posInterval: null,
    services: {
      users: feathersClient.service('users'),
      xlsx: feathersClient.service('xlsx'),
      entities: feathersClient.service('entities'),
      photos: feathersClient.service('photos'),
      pdfs: feathersClient.service('pdfs'),
      'upload-test': feathersClient.service('upload-test')
    },
    info: {},
    stats: {
      users: []
    },
    mapCenter: JSON.parse(localStorage.getItem('mapCenter')) || {
      lat: 44.4472043,
      lng: 26.0917751
    },
    zoom: Number(localStorage.getItem('zoom')) || 17,
    mapType: localStorage.getItem('mapType') || 'satellite',
    zoomDetailsPage: Number(localStorage.getItem('zoomDetailsPage')) || 17,
    mapTypeDetailsPage: localStorage.getItem('mapTypeDetailsPage') || 'satellite',
    settingsDetailsPage: localStorage.getItem('settingsDetailsPage') || [
      'info adresa',
      'info scara blocului',
      'info consum',
      'info lift'
    ],

    messages: [],
    messagesOpen: false,
    isDetailsEdited: false,
    refreshCount: 0
  },
  getters: {
    user: state => state.auth.user,
    token: state => state.auth.token,
    info: state => state.info,
    stats: state => state.stats,
    loading: state => state.loading,
    serverURL: state => state.serverURL,
    light: state => state.light,
    online: state => state.online,
    mapCenter: state => state.mapCenter,
    currentPosition: state => {
      const pos = state.auth.user ? state.auth.user.currentPosition : null
      if (pos && pos.lat && pos.lng) return pos
      return {
        lat: 44.4472043,
        lng: 26.0917751
      }
    },
    zoom: state => state.zoom,
    mapType: state => state.mapType,
    zoomDetailsPage: state => state.zoomDetailsPage,
    mapTypeDetailsPage: state => state.mapTypeDetailsPage,
    settingsDetailsPage: state => state.settingsDetailsPage,
    messages: state => state.messages,
    messagesOpen: state => state.messagesOpen,
    isDetailsEdited: state => state.isDetailsEdited,
    refreshCount: state => state.refreshCount
  },
  mutations: {
    setLight (state, payload) {
      state.light = payload
      localStorage.setItem('light', payload)
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setToken (state, payload) {
      Vue.set(state.auth, 'token', payload)
    },
    setUser (state, payload) {
      Vue.set(state.auth, 'user', payload)
    },
    addMessage (state, payload) {
      state.log.items.splice(0, 0, payload)
    },
    resetLog (state) {
      state.log.items.splice(0)
    },
    setOnline (state, payload) {
      state.online = payload
    },
    setWindowEventsState (state, payload) {
      state.windowEvents = payload
    },
    setCurrentPosition (state, payload) {
      Vue.set(state.auth.user, 'currentPosition', payload)
    },
    setInfo (state, payload) {
      Vue.set(state, 'info', payload)
    },
    setStats (state, payload) {
      Vue.set(state, 'stats', payload)
    },
    setMapCenter (state, payload) {
      state.mapCenter = payload
      localStorage.setItem('mapCenter', JSON.stringify(payload))
    },
    setZoom (state, payload) {
      state.zoom = payload
      localStorage.setItem('zoom', payload)
    },
    setMapType (state, payload) {
      state.mapType = payload
      localStorage.setItem('mapType', payload)
    },
    setZoomDetailsPage (state, payload) {
      state.zoomDetailsPage = payload
      localStorage.setItem('zoomDetailsPage', payload)
    },
    setMapTypeDetailsPage (state, payload) {
      state.mapTypeDetailsPage = payload
      localStorage.setItem('mapTypeDetailsPage', payload)
    },
    setSettingsDetailsPage (state, payload) {
      state.settingsDetailsPage = payload
      localStorage.setItem('settingsDetailsPage', payload)
    },
    saveMessage (state, payload) {
      state.messages.unshift(payload)
      state.messages = state.messages.slice(0, 20)
    },
    deleteMessage (state, payload) {
      const index = state.messages.findIndex(m => m.id === payload)
      if (index > -1) state.messages.splice(index, 1)
    },
    deleteAllMessages (state, payload) {
      state.messages = []
    },
    setMessagesOpen (state, payload) {
      state.messagesOpen = payload
    },
    setIsDetailsEdited (state, payload) {
      state.isDetailsEdited = payload
    },
    incrementRefreshCount (state, payload) {
      if (!state.refreshCount) {
        state.refreshCount = 1
      }
    },
    resetRefreshCount (state, payload) {
      state.refreshCount = 0
    }
  },
  actions: {
    async login ({ commit, dispatch }, data) {
      // commit('setLoading', true)

      let auth = null

      if (data) {
        await dispatch('logout')
        auth = feathersClient.authenticate({
          strategy: 'local',
          email: data.email,
          password: data.password
        })
      } else {
        const token = await feathersClient.passport.getJWT()
        if (token) auth = feathersClient.authenticate()
      }

      let user = null
      let token = null

      if (auth) {
        return auth.then(response => {
          user = response.user
          token = response.accessToken
          return feathersClient.passport.verifyJWT(response.accessToken)
        }).then(response => {
          dispatch('setEventWatchers')
          // dispatch('setOnlineOfflineHandler')
          dispatch('saveMessage', {
            user: user._id,
            text: `Autentificare reusita! Bine ai venit, ${user.username}!`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'info'
          })
          commit('setUser', user)
          commit('setToken', token)
          dispatch('getInfo')
          dispatch('entities/fetchEntities')
          // dispatch('entities/fetchAllEntities')
          dispatch('entities/setupWorker')
          // commit('setLoading', false)
          return Promise.resolve(user)
        }).catch(error => {
          console.log(error)
          dispatch('logout')
          commit('addMessage', {
            _id: uniqid(),
            text: error.name === 'NotAuthenticated' ? 'Autentificare esuata. Date invalide...' : error.message,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error',
            local: true
          })
          return Promise.reject(new Error('Nope. Date invalide, bro!'))
        })
      } else {
        return Promise.reject(new Error('No token found. Use the Login form.'))
      }
    },
    async logout ({ state, commit, dispatch }) {
      if (state.auth.user) {
        await dispatch('clearMessages')
        commit('resetLog')
      }
      feathersClient.logout()
      commit('setToken', null)
      return commit('setUser', null)
    },
    saveMessage ({ state, commit }, payload) {
    },
    clearMessages ({ state }) {

    },
    setEventWatchers ({ state, commit, dispatch }) {
      state.services.entities.events.forEach(event => {
        state.services.entities.on(event, debounce(data => {
          // dispatch('entities/fetchEntities')
          // dispatch('getInfo')
          commit('incrementRefreshCount')
        }, 5000))
      })

      state.services.users.on('patched', data => {
        console.log('setting user')
        // commit('setUser', data)
      })
    },
    getLocation ({ state, commit }) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          // hack
          commit('setCurrentPosition', { lat: position.coords.latitude, lng: position.coords.longitude })
          commit('setMapCenter', { lat: position.coords.latitude, lng: position.coords.longitude })
          // end hack
          state.services.users.patch(state.auth.user._id, {
            currentPosition: { lat: position.coords.latitude, lng: position.coords.longitude },
            lastMapCenter: { lat: position.coords.latitude, lng: position.coords.longitude }
          })
        }, (err) => {
          if (err.code === 1) {
            alert('Pentru ca aplicatia sa functioneze in conditii optime, va rugam sa permiteti accesul la pozitia d-voastra geografica!')
          } else if (err.code === 2) {
            alert('Sistemul d-voastra a raportat o eroare la incercarea de a gasi coordonatele d-voastra.')
            // clearInterval(geoWatch)
          } else {
            // alert('eroare la geolocation')
          }
        }, {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: 10000
        })
      }
    },
    setOnlineOfflineHandler ({ state, commit }) {
      if (!state.windowEvents) {
        window.addEventListener('online', handleConnection)
        window.addEventListener('offline', handleConnection)
        commit('setWindowEventsState', true)
      } else {
        handleConnection()
      }

      function handleConnection () {
        if (navigator.onLine) {
          isReachable(window.location.origin).then(online => {
            if (online) {
              commit('setOnline', 'on')
              // console.log('online')
            } else {
              commit('setOnline', 'lie-fi')
              // console.log('no connectivity')
            }
          })
        } else {
          commit('setOnline', 'off')
          // console.log('offline')
        }
      }

      function isReachable (url) {
        /**
         * Note: fetch() still "succeeds" for 404s on subdirectories,
         * which is ok when only testing for domain reachability.
         *
         * Example:
         *   https://google.com/noexist does not throw
         *   https://noexist.com/noexist does throw
         */

        const controller = new AbortController()
        const signal = controller.signal

        const timeoutId = setTimeout(() => controller.abort(), 5000)

        return fetch(url, { method: 'HEAD', mode: 'no-cors', signal })
          .then(resp => {
            clearTimeout(timeoutId)
            return resp && (resp.ok || resp.type === 'opaque')
          })
          .catch(err => {
            clearTimeout(timeoutId)
            console.warn('[conn test failure]:', err)
          })
      }

      handleConnection()
      setInterval(handleConnection, 60 * 1000)
    },
    setMapCenter ({ state }, payload) {
      state.services.users.patch(state.auth.user._id, {
        lastMapCenter: payload
      })
    },
    setZoom ({ state }, payload) {
      state.services.users.patch(state.auth.user._id, {
        zoom: payload
      })
    },
    setMapType ({ state }, payload) {
      state.services.users.patch(state.auth.user._id, {
        mapType: payload
      })
    },
    getInfo ({ state, commit }) {
      fetch(`${state.serverURL}/rest-getInfo`, {
        headers: new Headers({
          'Authorization': state.auth.token
        })
      })
        .then(result => {
          if (result.ok) {
            result.json()
              .then(data => {
                commit('setInfo', data)
              })
          }
        })
    },
    async getStats ({ state, commit }) {
      const stats = {
        users: []
      }
      stats.users = await state.services.users.find({ query: { $paginate: false, $select: [ 'username', 'avatar' ], admin: false } })

      for (let user of stats.users) {
        user.photos = (await state.services.photos.find({
          query: {
            user: user._id,
            $limit: 0
          }
        })).total

        const userStats = await fetch(
          `${state.serverURL}/rest-getStats?user=${user._id}`,
          {
            headers: new Headers({
              'Authorization': state.auth.token
            })
          }
        )

        const userStatsJson = await userStats.json()

        user.simboluri = userStatsJson.entityCount[0] ? userStatsJson.entityCount[0].total : 0
        // user.etichete = userStatsJson.labelCount
      }
      commit('setStats', stats)
    },
    dowloadZip ({ state }, payload) {
      return fetch(`${state.serverURL}/rest-download`, {
        method: 'post',
        headers: new Headers({
          'Authorization': state.auth.token,
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(payload)
      })
    },
    dowloadPdfsZip ({ state }, payload) {
      return fetch(`${state.serverURL}/rest-download-pdfs`, {
        method: 'post',
        headers: new Headers({
          'Authorization': state.auth.token,
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(payload)
      })
    },

    setZoomDetailsPage ({ state }, payload) {
      state.services.users.patch(state.auth.user._id, {
        lastMapCenterDetailsPage: payload
      })
    },
    setMapTypeDetailsPage ({ state }, payload) {
      state.services.users.patch(state.auth.user._id, {
        mapTypeDetailsPage: payload
      })
    }
  }
})
